import axios from 'axios'

// Call sites always include the `/api` prefix themselves (e.g. api.get('/api/user')),
// so a trailing /api on REACT_APP_API_URL would double up (.../api/api/user). Strip it
// here rather than relying on every environment's env var to omit it — env.example
// documents REACT_APP_API_URL="http://localhost:5000/api" for local dev, while deployed
// environments leave it unset (relative to the same origin nginx proxies /api/* from).
const baseURL = (process.env.REACT_APP_API_URL || '').replace(/\/api\/?$/, '')

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default api
